import scrollMonitor from 'scrollmonitor'

class AnimatedEntry {
  constructor () {
    this._element = document.querySelectorAll('.o-animated-entry')
    this._init()
  }

  _init () {
    for (let i=0; i < this._element.length; i++) {
      let el = this._element[i]
      let watcher = scrollMonitor.create(el)
      watcher.enterViewport(() => {
        el.classList.remove('o-animated-entry--below')
        el.classList.remove('o-animated-entry--above')
      })

      if (watcher.isInViewport) {
        el.classList.remove('o-animated-entry--below')
        el.classList.remove('o-animated-entry--above')
      }
      else if (watcher.isBelowViewport) {
        el.classList.add('o-animated-entry--below')
      } else if (watcher.isAboveViewport) {
        el.classList.add('o-animated-entry--above')
      }
    }
  }
}

export default new AnimatedEntry()
